import React from 'react'
import { compose } from 'redux'
import config from 'config'

import withApolloProvider from 'components/hocs/withApolloProvider'
import RichCta from 'components/rich-cta'
import StudentLoanForm from 'components/form/student-loan'
import WidgetPage from 'components/hocs/widget-page'
import useActiveLenders from 'components/hooks/useActiveLenders'

export const RichCtaApp = (props) => {
  const lendersList = useActiveLenders('in_school')
  const lendersCount = lendersList.length

  return (
    <RichCta
      url={`${config.credibleRoot}/student-loans`}
      title="Save money with the right private student loan."
      body={`Compare student loan rates from ${lendersCount} lenders in minutes.`}
      ctaText="Get Started"
      form={StudentLoanForm}
      {...props}
    />
  )
}

export default compose(withApolloProvider, WidgetPage)(RichCtaApp)
